import { makeSx } from '../../../theme/_utils'
import { defaultPalette } from '../../../theme/idsTheme'

export default makeSx({
    fullScreenCallout: {
        width: '100%',
        padding: '1.15rem 2.125rem',
        gap: '2.125rem',
    },
    fullScreenCalloutIconContainer: {
        '& svg': {
            width: '1.5rem',
            height: '1.5rem',
        },
    },
    fullScreenCalloutContentContainer: {
        fontWeight: 600,
    },
    fullScreenCalloutTitle: {
        fontWeight: 700,
    },
    fullScreenCalloutActionButtonBase: {
        minWidth: '7rem',
        height: 'fit-content',
        padding: '0.625rem 1rem 0.625rem 1.5rem',
        gap: '0.625rem',
        color: defaultPalette.white.main,
        transition: 'opacity 0.2s ease-out',
        '& .MuiButton-endIcon > svg': {
            width: '1.5rem',
            height: '1.5rem',
            margin: 0,
        },
    },
    fullScreenCalloutMoreInfoButton: {
        width: 'fit-content',
        padding: 0,
        fontSize: '0.875rem',
        textDecoration: 'underline',
        color: defaultPalette.typography.half,
        gap: 0,
        '& .MuiButton-icon': {
            margin: 0,
        },
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    fullScreenCalloutExpandedContent: {
        color: defaultPalette.typography.half,
        fontSize: '0.875rem',
    },
    fullScreenCalloutWarningContainer: {
        backgroundColor: defaultPalette.orangeWarning.half,
    },
    fullScreenCalloutWarning: {
        color: defaultPalette.orangeWarning.main,
    },
    fullScreenCalloutActionButtonWarning: {
        backgroundColor: defaultPalette.orangeWarning.main,
        '&:hover': {
            backgroundColor: defaultPalette.orangeWarning.main,
            opacity: 0.75,
        },
    },
    fullScreenCalloutErrorContainer: {
        // No color value for the moment, need to update
        backgroundColor: defaultPalette.error.main,
    },
    fullScreenCalloutError: {
        color: defaultPalette.error.main,
    },
    fullScreenCalloutActionButtonError: {
        backgroundColor: defaultPalette.error.main,
    },
    fullScreenCalloutInfoContainer: {
        // No color value for the moment, need to update
        backgroundColor: defaultPalette.primary.main,
    },
    fullScreenCalloutInfo: {
        color: defaultPalette.primary.main,
    },
    fullScreenCalloutActionButtonInfo: {
        backgroundColor: defaultPalette.primary.main,
    },
})
